<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showMerchantCreateStoreSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="cs-header-title">{{editableStore ? 'Edit' : 'Create'}} store</div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 160px)'}"
                       [styleClass]="'app-scrollpanel'">

            <div id="map" style="height: 250px; border: 0.5px solid #0040604D; border-radius: 10px; margin-bottom: 18px; margin-top: 30px;"></div>

            <div class="store-map-info">
                Tip: You can manually move the pin for exact location. The Address will automatically update based upon pin location.
            </div>

            <div class="merchant-form">
                <div class="merchant-label">Street Address</div>
                <p-autoComplete [(ngModel)]="store.Address"
                                [suggestions]="addresses"
                                (completeMethod)="search($event)"
                                placeholder="Search Google Maps"
                                (click)="geocodeClick()"
                                [inputStyle]="{'width': '645px', 'padding': '10px 15px'}">
                </p-autoComplete>
            </div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Location Details</div>
                        <input type="text" [(ngModel)]="store.Name" placeholder="Location Name" pInputText />
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">
                            <br />
                        </div>
                        <p-dropdown placeholder="Location Type" [(ngModel)]="store.LocationTypeId" [options]="locationType"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
            </div>

            <div class="merchant-form">
                <div class="merchant-label"></div>
                <input type="text" [(ngModel)]="store.AddressDetails" placeholder="Additional Details (Floor, Unit, etc)" pInputText />
            </div>

            <div class="merchant-form">
                <div class="merchant-label">Location Photo(s) (not published)</div>
            </div>
            <div class="flex flex-row">
                <div class="store-upload-img-block" *ngIf="store.ImageUrl">
                    <img src="{{store.ImageUrl}}" class="store-upload-img" />
                </div>

                <div class="store-upload-img-block">
                    <input id="idImgInput"
                           type="file"
                           accept="image/*"
                           style="display: none"
                           (change)="handleImageChange($event)" required />
                    <div class="store-upload-img__add-link" (click)="handleImageClick('idImgInput')">
                        <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                        <div class="store-upload-img__add-title">
                            Add
                        </div>
                    </div>
                </div>
            </div>

        </p-scrollPanel>
        
        <div class="flex justify-content-end mrg-10-0px">
            <button class="red-btn" pButton label="Cancel" style="margin-right: 10px;" (click)="cancel()"></button>
            <button class="bluedark-btn" pButton label="{{editableStore ? 'Save Changes' : 'Save'}}" (click)="createOrEditStore()"></button>
        </div>
    </div>
</p-sidebar>